export const GOLD_USD_INTRO =
  'Is gold behaving normally, or acting as a stress haven? Use USD-priced gold (GLD). ' +
  'Weak USD usually lifts gold; gold and USD rising together is a stress flag.';

export const REGIME_ROWS = [
  {
    id: 'normal',
    range: '≤ −0.30',
    label: 'Normal',
    emoji: '🟢',
    tooltip: 'Weak dollar lifts gold — usual mechanical link.',
  },
  {
    id: 'decoupled',
    range: '−0.30 to +0.30',
    label: 'Decoupled',
    emoji: '🟡',
    tooltip: 'Gold driven by other factors (real yields, CB buying, flows).',
  },
  {
    id: 'stress_haven',
    range: '≥ +0.30',
    label: 'Stress haven',
    emoji: '🔴',
    tooltip: 'Gold and USD rise together — fear-driven haven demand.',
  },
];

const NORMAL = -0.3;
const STRESS = 0.3;

export function fmtSignedCorr(value) {
  if (value == null || Number.isNaN(value)) return '—';
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}`;
}

export function regime(c) {
  if (c == null || Number.isNaN(c)) {
    return { id: 'unknown', label: '—', emoji: '', cssClass: 'neutral' };
  }
  if (c <= NORMAL) return { ...REGIME_ROWS[0], cssClass: 'normal' };
  if (c >= STRESS) return { ...REGIME_ROWS[2], cssClass: 'stress' };
  return { ...REGIME_ROWS[1], cssClass: 'decoupled' };
}

export function situationAtPoint(c30, c60, c90) {
  const r90 = regime(c90);
  const r30 = regime(c30);
  const headline =
    r90.id === 'stress_haven'
      ? 'Stress haven — gold and USD rising together.'
      : r90.id === 'normal'
        ? 'Normal — gold responding to USD.'
        : r90.id === 'decoupled'
          ? 'Decoupled — gold off the dollar.'
          : 'Regime unclear.';
  const detail = `30d ${fmtSignedCorr(c30)}; 60d ${fmtSignedCorr(c60)}; 90d ${fmtSignedCorr(c90)}. ${r90.tooltip || ''}`;
  return { headline, detail, r90, r30, primaryCss: r90.cssClass };
}

export function pickCorr(bars, time) {
  return bars?.find((b) => b.time === time)?.value ?? null;
}
